import Vue from 'vue'
import Router from 'vue-router'
import homeRoutes from '@/modules/home/routes'
import hubRoutes from '@/modules/gerenciador-analises/routes'
import clubeRoutes from '@/modules/clube/routes'
import clientesRoutes from '@/modules/clientes/routes'
import mariaRoutes from '@/modules/maria/routes'
import empresaRoutes from '@/modules/empresa/routes'
import produtosRoutes from '@/modules/produtos/routes'
import campanhasRoutes from '@/modules/campanhas/routes'
import industriaRoutes from '@/modules/industria/routes'
import errosRoutes from '@/modules/erros/routes'
import usuariosRoutes from '@/modules/usuarios/routes'
import calendarioPromocionalRoutes from '@/modules/calendario-promocional/routes'
import pedidosRoutes from '@/modules/pedidos/routes'
import mobileRoutes from '@/modules/mobile/routes'
import configuracoesRoutes from '@/modules/configuracoes/routes'
import configuracoesAdminRoutes from '@/modules/configuracoes-admin/routes'

Vue.use(Router)

export default new Router({
  routes: [
    ...homeRoutes,
    ...empresaRoutes,
    ...clientesRoutes,
    ...clubeRoutes,
    ...mariaRoutes,
    ...campanhasRoutes,
    ...industriaRoutes,
    ...produtosRoutes,
    ...usuariosRoutes,
    ...errosRoutes,
    ...calendarioPromocionalRoutes,
    ...pedidosRoutes,
    ...mobileRoutes,
    ...configuracoesRoutes,
    ...configuracoesAdminRoutes,
    ...hubRoutes,
  ],
})
